import { initializeApp } from "firebase/app";
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
} from "firebase/auth";
import {
    getFirestore,
    query,
    getDocs,
    collection,
    where,
    addDoc,
} from "firebase/firestore";
import {
  getDatabase
} from "firebase/database";
import {
    getStorage
} from "firebase/storage";
import {GLOBAL_CONFIG} from "./global_config";
import {track} from "@amplitude/analytics-browser";
import {message} from "antd";

const app = initializeApp(GLOBAL_CONFIG.firebase_config);
const auth = getAuth(app);
const database = getDatabase(app);
const storage = getStorage();
const resultsStorage = getStorage(app, GLOBAL_CONFIG.outputs_bucket_path);
const defaultAssetsStorage = getStorage(app, GLOBAL_CONFIG.default_assets_bucket_path);
const default3DAssetsStorage = getStorage(app, GLOBAL_CONFIG.default_3d_assets_bucket_path);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

const signInWithGoogle = async () => {
    track("signin_clicked", { type: "google" });
    try {
        const res = await signInWithPopup(auth, googleProvider);
        const user = res.user;
        const q = query(collection(db, "users"), where("uid", "==", user.uid));
        const docs = await getDocs(q);
        if (docs.docs.length === 0) {
            await addDoc(collection(db, "users"), {
                uid: user.uid,
                name: user.displayName,
                authProvider: "google",
                email: user.email,
            });
        }
    } catch (err) {
        console.error(err);
        message.error(err.message);
    }
};

const logInWithEmailAndPassword = async (email, password) => {
    track("signin_clicked", { type: "email" });
    try {
        await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
        console.error(err);
        message.error(err.message);
    }
};

const registerWithEmailAndPassword = async (name, email, password) => {
    track("register_clicked", { type: "email" });
    try {
        const res = await createUserWithEmailAndPassword(auth, email, password);
        const user = res.user;
        await addDoc(collection(db, "users"), {
            uid: user.uid,
            name,
            authProvider: "local",
            email,
        });
    } catch (err) {
        console.error(err);
        message.error(err.message);
    }
};

const sendPasswordReset = async (email) => {
    try {
        await sendPasswordResetEmail(auth, email);
        message.info("Password reset link sent!");
    } catch (err) {
        console.error(err);
        message.error(err.message);
    }
};

const logout = () => {
    signOut(auth);
};

export {
    auth,
    database,
    storage,
    defaultAssetsStorage,
    default3DAssetsStorage,
    resultsStorage,
    signInWithGoogle,
    logInWithEmailAndPassword,
    registerWithEmailAndPassword,
    sendPasswordReset,
    logout,
};